<template>
    <AuthLayout v-bind="appSharedData.getAuthLayoutProps()">
        <template #title> Invite </template>

        <template #card-content>
            <div class="flex flex-col items-center space-y-4">
                <div v-if="localCompany.logoImage">
                    <Image
                        class="max-w-20 h-auto rounded-lg2 overflow-hidden"
                        :src="localCompany.logoImage.url"
                        alt="logo"
                    />
                </div>
                <div class="text-center">
                    <span class="font-semibold">{{
                        localCompany.displayName
                    }}</span>
                    wants to work with you, click the button below to accept the
                    invitation.
                </div>
            </div>

            <div class="space-y-4">
                <div>
                    <ApiForm
                        :url="
                            urlFactory.makeAcceptInvitePageUrl(
                                localCompanyUserInvite.id,
                            )
                        "
                        method="POST"
                        ref="apiFormRef"
                    >
                        <input
                            type="text"
                            name="company"
                            class="optional"
                        />
                        <FormControl>
                            <Button
                                @click="apiFormRef?.submit()"
                                :loading="apiFormRef?.loading.valueOf()"
                                class="w-full mt-2"
                            >
                                Accept Invite
                            </Button>
                        </FormControl>
                    </ApiForm>
                </div>
            </div>
        </template>
    </AuthLayout>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import AuthLayout from '@/Shared/Layout/App/Auth/AuthLayout.vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import Button from '@/Shared/Component/Button.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import AppSharedData from '@/Shared/Entity/AppSharedData'
    import Company from '@/App/Company/Entity/Company'
    import CompanyUserInvite from '@/App/CompanyUserInvite/Entity/CompanyUserInvite'
    import Image from '@/Shared/Component/Image.vue'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'

    interface ShowCompanyUserAcceptInviteProps {
        companyUserInviteData: any
        appSharedDataData: any
        companyData: any
    }

    const props = defineProps<ShowCompanyUserAcceptInviteProps>()
    const urlFactory = new UrlFactory()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const apiFormRef = ref<ApiFormRefType>(null)
    const localCompanyUserInvite = CompanyUserInvite.hydrateSingle(
        props.companyUserInviteData,
    )
    const localCompany = Company.hydrateSingle(props.companyData)
</script>
